import React from 'react'
import animationData from 'images/lotties/gmailloading.json';
// eslint-disable-next-line
import Lottie from 'react-lottie'
import clsx from 'clsx';
import styles from './LoaderEye.module.scss'

export default function LoaderEye({
  className,
}: { className?: string }) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  return (
    <div className={clsx(styles.loader, className)}>
      {/* @ts-ignore */}
      <Lottie
        options={defaultOptions}
        height="100%"
        width="100%"
      />
    </div>

  )
}
